import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function StageGroupFormDialog({ open, onClose, group, onSave }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", code: "", description: "" });

  useEffect(() => {
    if (group) {
      setForm({
        name: group.name ?? "",
        code: group.code ?? "",
        description: group.description ?? "",
      });
    } else {
      setForm({ name: "", code: "", description: "" });
    }
  }, [group, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      name: form.name.trim() || null,
      code: form.code.trim() || "",
      description: form.description.trim() || "",
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{group ? t("academic.editGroup", "Edit group") : t("academic.addGroup", "Add group")}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <TextField fullWidth required name="name" label={t("academic.groupName", "Group name")} value={form.name} onChange={handleChange} size="small" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth name="code" label={t("academic.groupCode", "Code (optional)")} value={form.code} onChange={handleChange} size="small" placeholder="e.g. G1, Group A" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth name="description" label={t("academic.description", "Description")} value={form.description} onChange={handleChange} size="small" multiline rows={2} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("common.cancel", "Cancel")}</Button>
          <Button type="submit" variant="contained" disabled={!form.name.trim()}>{t("common.save", "Save")}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
